var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 54,
    height: 54,
    transform: "translate(0.001 0)",
    fill: "#111e72"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M39.969,35.451a5.308,5.308,0,0,0-7.546,0l-2.571,2.575a46.491,46.491,0,0,1-8.006-6.438,47.844,47.844,0,0,1-6.427-8.02l2.571-2.575a5.331,5.331,0,0,0,0-7.56L12.97,8.412A5.2,5.2,0,0,0,9.225,6.846,5.357,5.357,0,0,0,5.442,8.412l-2.414,2.4A11.346,11.346,0,0,0,.116,20.148C.68,26.819,5.054,34.839,11.777,41.6s14.83,11.115,21.489,11.755a13,13,0,0,0,1.489,0,10.771,10.771,0,0,0,7.83-2.917l2.4-2.419a5.376,5.376,0,0,0,1.562-3.79,5.214,5.214,0,0,0-1.562-3.752Zm2.507,10.06-2.414,2.4a8.094,8.094,0,0,1-6.5,1.779C27.79,49.2,20.441,45.1,14.374,39.017S4.221,25.633,3.667,19.851a8.061,8.061,0,0,1,1.775-6.512l2.507-2.419a1.787,1.787,0,0,1,2.514,0l5.03,5.087a1.793,1.793,0,0,1,0,2.511l-3.551,3.557a1.769,1.769,0,0,0-.286,2.149,48.716,48.716,0,0,0,7.684,9.92,48.7,48.7,0,0,0,9.914,7.707,1.771,1.771,0,0,0,2.145-.287l3.551-3.557a1.782,1.782,0,0,1,2.5,0l5.023,5.03a1.828,1.828,0,0,1,.516,1.271,1.749,1.749,0,0,1-.516,1.2m3.087-37.7A26.437,26.437,0,0,0,26.747,0a1.779,1.779,0,0,0,0,3.557,23.116,23.116,0,0,1,23.08,23.316,1.775,1.775,0,1,0,3.551,0A26.536,26.536,0,0,0,45.563,7.809",
    transform: "translate(0 0.288)",
    fill: "#111e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M20.345,11.482a10.727,10.727,0,0,1,3.144,7.669,1.775,1.775,0,1,0,3.551,0,14.223,14.223,0,0,0-14.2-14.414,1.779,1.779,0,0,0,0,3.557,10.681,10.681,0,0,1,7.509,3.187",
    transform: "translate(15.122 6.786)",
    fill: "#111e72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.87778a59a17263532a14ada130685a36.svg";
export { ForwardRef as ReactComponent };